import { render, staticRenderFns } from "./company-customer.vue?vue&type=template&id=bf60600a&scoped=true&"
import script from "./company-customer.vue?vue&type=script&lang=js&"
export * from "./company-customer.vue?vue&type=script&lang=js&"
import style0 from "./company-customer.vue?vue&type=style&index=0&id=bf60600a&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bf60600a",
  null
  
)

export default component.exports